import { AfterViewInit, Component, ElementRef, HostListener, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { CampuscctvserviceService } from '../service/campuscctvservice.service';
import { VideoComponent } from '../video/video.component';
import * as $ from 'jquery'
import 'datatables.net';
import 'datatables.net-bs4';
import { HttpRequest } from '@angular/common/http';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import autoTable from 'jspdf-autotable';
import { ViewalldailogComponent } from '../viewalldailog/viewalldailog.component';
import { VideostreamingComponent } from '../videostreaming/videostreaming.component';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { TotaldvrDialogComponent } from '../totaldvr-dialog/totaldvr-dialog.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { ErrorService } from '../error.service';
import { ExcelService } from './excel.service';
import { TotaldvreditDialogComponent } from '../totaldvredit-dialog/totaldvredit-dialog.component';
import { ToastmessageService } from '../toastmessage.service';
import { HighchartsService } from '../piechart/highcharts.service';

// import {ResizeEvent} from 'angular-resizable-element';


// Define an interface to match the expected data structure
interface CctvDvrDetail {
  buildingName: string;
  ipAddress: string;
  rtspPortNo: number;
  dvrModelNumber: string;
  // serialNumber: string;
  dvrSystemDate: string;
  totalCamerasInstalled: number;
  totalConnected: number;
  totalNotConnected: number;
  dvrCheckDate: string;
  hdStatus: string;
  dvrPresentWorkingStatus: string;
}


@Component({
  selector: 'app-totaldvr',
  templateUrl: './totaldvr.component.html',
  styleUrls: ['./totaldvr.component.scss']
})
export class TotaldvrComponent implements OnInit, AfterViewInit {
  business: string[] = ["COLLEGE", "SCHOOL"];

  @ViewChild('searchInputcampus') searchInputcampus!: ElementRef;

  servicelist: any;
  displayedColumns: string[] = [
    'sNo', 'cityName', 'buildingFusionCode', 'buildingName', 'ipAddress', 'httpPortNo', 'rtspPortNo', 'dvrModelNumber', 'dvrSystemDate', 'dvrCheckDate',
    'totalCamerasInstalled', 'totalConnected', 'totalNotConnected', 'hdStatus','hdCapacity', 'dvrPresentWorkingStatus', 'view', 'edit'
  ];

  public searchTerm: string = '';
  // dataSource = new MatTableDataSource<CctvDvrDetail>([]);
  totalcctvdata: any
  totalcctvdatalist: any;
  dataAvailable = true; // New variable to track data availability
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  isshow: boolean = true;
  totaldvr: any
  isExpanded = true;
  datatable: any;
  list: any;
  data1: any;
  active: boolean = false;
  card: boolean = false;
  data2: any;
  @ViewChild('example') example!: ElementRef;
  selectedRow: any;
  uniqueCctvDetId: any;
  updateCCtvdetails: any;
  pwdeye: any;
  datauniqe: any;
  blgName: any;
  buldingdetails: any;
  campusQuery: string = '';
  stateQuery: string = '';
  businessName: any = this.business[0];
  CityDetailsName: any;
  stateNames: any;
  stateId: any;
  filterValue: string='';
  // user: any;
  constructor(private el: ElementRef, public campuscctvserviceservice: CampuscctvserviceService, private dailog: MatDialog, public dialog1: NgDialogAnimationService, private spinner: NgxSpinnerService, private errorService: ErrorService, private excelService: ExcelService, private campusservice: CampuscctvserviceService, private toast: ToastmessageService, private highcharts: HighchartsService) { }

  ngOnInit(): void {
    this.AllServices();
    // this.loadData();
    this.selectBusinessType(this.businessName)

  }

  ngAfterViewInit(): void {
    this.focusSearchInput();
  }

  applyFilter(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value;
    this.totalcctvdata.filter = this.filterValue.trim().toLowerCase();
    console.log('filterValue', this.filterValue);
  }


  // new future //

  focusSearchInput() {
    if (this.searchInputcampus) {
      this.searchInputcampus.nativeElement.focus();
    }
  }
  // select business type //
  selectBusinessType(business: any) {
    this.businessName = business;
    console.log('businessName', this.businessName);
    this.stateNames = '';
    this.CityDetailsName = [];
    this.getState(business);
    this.getTotalDvrList();
  }

  getState(busineeName: any) {
    this.spinner.show();
    this.campusservice.getTableBusniessType(this.businessName).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return
        }
        this.CityDetailsName = res;
        console.log('CityDetailsName', this.CityDetailsName);
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
      }
    })
  }

  getTotalDvrList() {
    const payload =
    {
      "filterBy": "SEGMENT",
      "id": "string",
      "businessType": this.businessName
    }
    this.spinner.show();
    
    this.campusservice.postDvrList(payload).subscribe(
      {
        next: (data: any) => {
          if (!data || !data.cctvDvrDetails || data.cctvDvrDetails.length === 0) {
            console.log('daaa', data);
            this.totalcctvdatalist = [];
            this.totalcctvdata = new MatTableDataSource([]);
            this.dataAvailable = false;
            this.spinner.hide();
            return;
          }
          this.totalcctvdatalist = data.cctvDvrDetails;
          this.datauniqe = this.totalcctvdatalist;
          if (data && data.cctvDvrDetails.length > 0) {
            this.totalcctvdata = new MatTableDataSource(data.cctvDvrDetails);

            this.totalcctvdata.filterPredicate = (row: any, filter: any) => {
              const stateName = row.stateName?.toLowerCase() || '';
              const cityName = row.cityName?.toLowerCase() || '';
              const buildingName = row.buildingName?.toLowerCase() || '';
              const buildingFusionCode = row.buildingFusionCode?.toLowerCase() || '';
              const ipAddress = row.ipAddress?.toLowerCase() || '';
              const dvrModelNumber = row.dvrModelNumber?.toLowerCase() || '';
              const httpPortNo = row.httpPortNo?.toString() || '';
              const rtspPortNo = row.rtspPortNo?.toString() || '';
              const hdStatus = row.hdStatus?.toLowerCase() || '';

              return (
                stateName.includes(filter) ||
                cityName.includes(filter) ||
                buildingName.includes(filter) ||
                buildingFusionCode.includes(filter) ||
                ipAddress.includes(filter) ||
                dvrModelNumber.includes(filter) ||
                httpPortNo.includes(filter) ||
                rtspPortNo.includes(filter) ||
                hdStatus.includes(filter)
              );
            };

            this.totalcctvdata.sort = this.sort;
            this.totalcctvdata.paginator = this.paginator;
            this.dataAvailable = true;
              this.spinner.hide();
          } else {
            this.dataAvailable = false;
              this.spinner.hide();
          }
        
        }, error: (error: any) => {
          this.dataAvailable = false;
          this.spinner.hide();
        }
      }
    )
  }

  selectState(data: any) {
    this.stateNames = data.stateName;
    this.stateId = data.stateId;
    console.log('City', data);
    this.stateWiseTotalDvrList()
  }
  // state table filter //

  stateWiseTotalDvrList() {
    const payload =
    {
      "filterBy": "STATE",
      "id": this.stateId,
      "businessType": this.businessName
    }
    this.spinner.show();
    this.campusservice.postDvrList(payload).subscribe(
      {
        next: (data: any) => {
          if (!data || !data.cctvDvrDetails || data.cctvDvrDetails.length === 0) {
            console.log('daaa', data);
            this.totalcctvdatalist = [];
            this.totalcctvdata = new MatTableDataSource([]);
            this.dataAvailable = false;
            this.spinner.hide();
            return;
          }
          this.totalcctvdatalist = data.cctvDvrDetails;
          this.datauniqe = this.totalcctvdatalist;
          if (data && data.cctvDvrDetails.length > 0) {
            this.totalcctvdata = new MatTableDataSource(data.cctvDvrDetails);

            this.totalcctvdata.filterPredicate = (row: any, filter: any) => {
              const stateName = row.stateName?.toLowerCase() || '';
              const cityName = row.cityName?.toLowerCase() || '';
              const buildingName = row.buildingName?.toLowerCase() || '';
              const buildingFusionCode = row.buildingFusionCode?.toLowerCase() || '';
              const ipAddress = row.ipAddress?.toLowerCase() || '';
              const dvrModelNumber = row.dvrModelNumber?.toLowerCase() || '';
              const httpPortNo = row.httpPortNo?.toString() || '';
              const rtspPortNo = row.rtspPortNo?.toString() || '';
              const hdStatus = row.hdStatus?.toLowerCase() || '';

              return (
                stateName.includes(filter) ||
                cityName.includes(filter) ||
                buildingName.includes(filter) ||
                buildingFusionCode.includes(filter) ||
                ipAddress.includes(filter) ||
                dvrModelNumber.includes(filter) ||
                httpPortNo.includes(filter) ||
                rtspPortNo.includes(filter) ||
                hdStatus.includes(filter)
              );
            };

            this.totalcctvdata.sort = this.sort;
            this.totalcctvdata.paginator = this.paginator;
            this.dataAvailable = true;
          } else {
            this.dataAvailable = false;
          }
          this.spinner.hide();
        }, error: (error: any) => {
          this.spinner.hide();
          this.dataAvailable = false;
        }
      }
    )
  }
  // SEARCH DETAILS //

  campusSearch(item: any) {
    // this.campusValue = (item.target as HTMLInputElement).value;
    // if (this.campusValue) {
    //   this.filteredCampusDetails = this.overallcampusDetails.filter((campus: any) =>
    //     campus.campusName.includes(this.campusValue) ||
    //     campus.campusName.toLowerCase().includes(this.campusValue.toLowerCase())
    //   );
    // } else {
    //   this.filteredCampusDetails = this.overallcampusDetails;
    // }
  }
  //End new future //


  // loadData() {
  //   this.spinner.show();
  //   this.campuscctvserviceservice.gettotaldvr().subscribe(
  //     {
  //       next: (data: any) => {
  //         if (!data) {
  //           this.spinner.hide();
  //           return;
  //         }
  //         this.totalcctvdatalist = data.cctvDvrDetails;
  //         this.datauniqe = this.totalcctvdatalist;
  //         if (data && data.cctvDvrDetails.length > 0) {
  //           this.totalcctvdata = new MatTableDataSource(data.cctvDvrDetails);

  //           // Customize filter predicate
  //           this.totalcctvdata.filterPredicate = (row: any, filter: any) => {
  //             const stateName = row.stateName?.toLowerCase() || '';
  //             const cityName = row.cityName?.toLowerCase() || '';
  //             const buildingName = row.buildingName?.toLowerCase() || '';
  //             const buildingFusionCode = row.buildingFusionCode?.toLowerCase() || '';
  //             const ipAddress = row.ipAddress?.toLowerCase() || '';
  //             const dvrModelNumber = row.dvrModelNumber?.toLowerCase() || '';
  //             const httpPortNo = row.httpPortNo?.toString() || '';
  //             const rtspPortNo = row.rtspPortNo?.toString() || '';
  //             const hdStatus = row.hdStatus?.toLowerCase() || '';

  //             return (
  //               stateName.includes(filter) ||
  //               cityName.includes(filter) ||
  //               buildingName.includes(filter) ||
  //               buildingFusionCode.includes(filter) ||
  //               ipAddress.includes(filter) ||
  //               dvrModelNumber.includes(filter) ||
  //               httpPortNo.includes(filter) ||
  //               rtspPortNo.includes(filter) ||
  //               hdStatus.includes(filter)
  //             );
  //           };

  //           this.totalcctvdata.sort = this.sort;
  //           this.totalcctvdata.paginator = this.paginator;
  //           this.dataAvailable = true;
  //         } else {
  //           this.dataAvailable = false;
  //         }
  //         this.spinner.hide();
  //       }, error: (error: any) => {
  //         this.spinner.hide();
  //         this.dataAvailable = false;
  //       }
  //     }
  //   )
  // }


  // this.alldata(data);

  // Export to PDF //

  // exporttopdf() {
  //   const htmlContent = document.querySelector('#example') as HTMLElement;
  //   this.campuscctvserviceservice.generatePdf(htmlContent, 'generated.pdf');
  // }

  //=====pdf angular====//
  // public exporttopdf() {
  //   let DATA: any = document.getElementById('example');
  //   html2canvas(DATA).then((canvas) => {
  //     let filewidth = 200;
  //     let fileheight = (canvas.height * filewidth) / canvas.width;
  //     const FILEURL = canvas.toDataURL('image/png');
  //     let pdf = new jsPDF('p', 'mm', 'a4');
  //     let position = 3;
  //     pdf.addImage(FILEURL, 'PNG', 3, position, filewidth, fileheight);
  //     pdf.save('angular-demo.pdf');
  //   })
  // }
  // Export to Excel//
  // exporttoexcel() {
  //   const table = document.querySelector('#example') as HTMLTableElement;
  //   this.campuscctvserviceservice.exportToExcel(table, 'exported_data');
  // }

  alldata(data: any) {
    this.selectedRow = data;
    let dialogRef = this.dialog1.open(TotaldvrDialogComponent, {
      data: data,
      disableClose: true,
      direction: 'ltr',
      height: '100%',
      width: '100%',
      position: { right: '0px', top: '0px' },
      animation: { to: "left" },

    });
  }
  editdata(data: any) {
    this.selectedRow = data;
    this.spinner.show();
    this.uniqueCctvDetId = data.uniqueCctvDetId
    this.campusservice.getcctvdetails(this.uniqueCctvDetId).subscribe(
      {
        next: (res: any) => {
          if (!res) {
            this.spinner.hide();
            return;
          }
          this.updateCCtvdetails = res;
          this.pwdeye = this.updateCCtvdetails.password;
          console.log('updateCCtvdetails', this.updateCCtvdetails);
          // this.edit(this.updateCCtvdetails);
          this.spinner.hide();
          const dialogRef = this.dialog1.open(TotaldvreditDialogComponent, {
            data: {
              pwdeye: this.pwdeye,
              updateCCtvdetails: this.updateCCtvdetails,
              data: data
            },
            // data: data,
            direction: 'ltr',
            height: '100%',
            width: '40%',
            position: { right: '0px', top: '0px' },
            animation: { to: "left" },
          });
          dialogRef.afterClosed()
            .subscribe(result => {
              if (result == 'save') {
                // this.loadData();
                this.getTotalDvrList();
                this.filterValue = '';                
                console.log('result', result);
              }
            });
        },
        error: (error: any) => {
          if (error.status === 422) {
            // this.dialogRef.close();
            this.toast.showError("Internal Server Error in DVR/NVR");
          }
          this.spinner.hide();
        }
      }
    );

    // this.selectedRow = data;
    // this.pwdeye = data;
    // this.updateCCtvdetails = data;


  }

  isSelected(row: any): boolean {
    return this.selectedRow === row;
  }

  exportAsXLSX(): void {
    console.log('exportexcel', this.totalcctvdatalist);
    let fieldsToExtract = ['stateName', 'cityName', 'buildingName', 'buildingFusionCode', 'ipAddress', 'rtspPortNo', 'httpPortNo', 'dvrModelNumber', 'dvrSystemDate', 'totalCamerasInstalled', 'totalConnected', 'totalNotConnected', 'dvrCheckDate', 'hdStatus', 'hdCapacity', 'dvrPresentWorkingStatus'];
    let filteredBuildings = this.extractFields(this.totalcctvdatalist, fieldsToExtract);
    this.excelService.exportAsExcelFile(filteredBuildings, 'totalcctvdatalist');
  }
  // Mapping of field names to user-friendly names
  fieldNameMapping: any = {
    stateName: 'stateName',
    cityName: 'City Name',
    buildingName: 'Building Name',
    buildingFusionCode: 'Fusion Code',
    ipAddress: 'Ip Address',
    rtspPortNo: 'RTSP No',
    httpPortNo: 'Server Port No',
    dvrModelNumber: 'Model Number',
    dvrSystemDate: 'Dvr Current Date',
    totalCamerasInstalled: 'Total Cameras Installed',
    totalConnected: 'Total Connected',
    totalNotConnected: 'Total NotConnected',
    dvrCheckDate: 'DVR Check Date',
    hdStatus: 'HD Status',
    hdCapacity: 'HD Capacity',
    dvrPresentWorkingStatus: 'Status'
  };

  extractFields(objects: any[], fields: string[]): any[] {
    return objects.map(obj => {
      const newObj: any = {};
      fields.forEach(field => {
        if (field in obj) {
          // Use the mapped name or default to the original field name
          const newName = this.fieldNameMapping[field] || field;
          newObj[newName] = obj[field];
        }
      });
      return newObj;
    });
  }

  AllServices() {
    if (this.highcharts.getRoles().length == 0) {
      this.spinner.show();
      this.highcharts.modulebaseurl().subscribe(
        {
          next: (res) => {
            if (!res) {
              this.spinner.hide();
              return;
            }
            this.servicelist = res;
            this.spinner.hide();
            console.log('service', this.servicelist);
            this.highcharts.setRoles(this.servicelist.moduleBaseURl);
            console.log('roleitem', this.highcharts.getRoles());
            this.getTotalDvrList();
            // this.loadData()
          },
          error: (error: any) => {
            this.spinner.hide();
          }
        }
      )
    }
  }




}




